import React, { PropsWithChildren } from 'react';

export type LoadingProps = {
	message?: string;
} & PropsWithChildren;

const Loading = (props: LoadingProps) => {
	const { children, message = 'Loading...' } = props;

	return (
		<div>
			<p>{message}</p>
			{children}
		</div>
	);
};

export default Loading;
